import { PeopleOutline, AttachMoney, AccessTime, CreditCardOutlined } from '@mui/icons-material';
import { MetricCard, type MetricCardProps } from 'finara-components';

interface MetricsGridProps {
  metrics: Record<string, MetricCardProps>;
  className?: string;
  variantOverride?: MetricCardProps['variant'];
}

const getIconForMetric = (key: string) => {
  const iconMap: Record<string, React.ReactNode> = {
    empleadosActivos: <PeopleOutline fontSize="inherit" />,
    nominaMensual: <AttachMoney fontSize="inherit" />,
    adelantosActivos: <CreditCardOutlined fontSize="inherit" />,
    tiempoPromedioPago: <AccessTime fontSize="inherit" />,
  };

  return iconMap[key] ?? <AttachMoney fontSize="inherit" />;
};

export const MetricsGrid: React.FC<MetricsGridProps> = ({
  metrics,
  className = 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6',
  variantOverride,
}) => {
  return (
    <div className={className}>
      {Object.entries(metrics).map(([key, metric]) => (
        <MetricCard
          key={key}
          title={metric.title}
          value={metric.value}
          description={metric.description}
          trendingUpText={metric.trendingUpText}
          trendingDownText={metric.trendingDownText}
          variant={variantOverride ?? metric.variant}
          icon={getIconForMetric(key)}
        />
      ))}
    </div>
  );
};
